import React, { useEffect, useState } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { CustomerDisplayProvider } from './context/CustomerDisplayContext'
import CustomerDisplayLayout from './CustomerDisplayLayout'
import BackgroundCompanyPage from './pages/BackgroundCompanyPage'
import ShoppingCartPage from './pages/ShoppingCartPage'
import DetailQuotePage from './pages/DetailQuotePage'
import ProductSearchPage from './pages/ProductSearchPage'
import { acquireCustomerDisplayWindowPresence } from './utils/customerDisplayPresence'

export default function CustomerDisplay() {
  const { path } = useRouteMatch()
  const [hasWindowOwnership, setHasWindowOwnership] = useState(false)

  useEffect(() => {
    let disposed = false
    let releaseWindowPresence = null

    const closeDuplicateCustomerDisplay = () => {
      try {
        window.close()
      } catch (error) {
        console.warn(
          'No se pudo cerrar la ventana duplicada de Customer Display:',
          error
        )
      }
    }

    acquireCustomerDisplayWindowPresence(closeDuplicateCustomerDisplay)
      .then(releasePresence => {
        if (disposed) {
          releasePresence?.()
          return
        }

        if (!releasePresence) {
          closeDuplicateCustomerDisplay()
          return
        }

        releaseWindowPresence = releasePresence
        setHasWindowOwnership(true)
      })
      .catch(error => {
        if (disposed) return

        console.warn(
          'No se pudo validar la ventana única de Customer Display:',
          error
        )
        closeDuplicateCustomerDisplay()
      })

    const releasePresence = event => {
      if (event?.persisted) return

      releaseWindowPresence?.()
      releaseWindowPresence = null
    }

    window.addEventListener('pagehide', releasePresence)

    return () => {
      disposed = true
      window.removeEventListener('pagehide', releasePresence)
      releasePresence()
    }
  }, [])

  if (!hasWindowOwnership) return null

  return (
    <CustomerDisplayProvider>
      <CustomerDisplayLayout>
        <Switch>
          <Route exact path={path} component={BackgroundCompanyPage} />
          <Route path={`${path}/cart`} component={ShoppingCartPage} />
          <Route path={`${path}/quote`} component={DetailQuotePage} />
          <Route path={`${path}/search`} component={ProductSearchPage} />
        </Switch>
      </CustomerDisplayLayout>
    </CustomerDisplayProvider>
  )
}
